<template>
	<div class="order-detail" v-if="form.id">
		<basic-container>
			<div class="c0 fs24 tac mb20 mt20">确认完善计划单</div>
			<div class="o-title">单号：<span class="num-family">{{form.initialPlanNo}}</span>（确认接收的执行机构都会生成计划单序号）</div>
			<avue-form ref="form" v-model="form" :option="option" @error="error">
				<!-- @submit="submit" -->
				<template slot="init">
					<orderinit :isShowBtn="false" :isOpt="false" :isShowTitle="false" :orderId="form.id"
						:list="form.orderInitialPlanList"></orderinit>
				</template>
				<template slot="detailInit">
					<orderinitDetail :isShowTitle="false" :orderInitId="$route.query.id"
						:initPlanList="form.orderInitialPlanList" :list="form.orderInitialPlanList.orderSpecificList"
						:date="new Date()" @returnInfo="returnInfoEven"></orderinitDetail>
				</template>
				<template slot-scope="scope" slot="menuForm">
					<el-button type="primary" icon="el-icon-check" :loading="submitBtnLoading" @click="submit">确认提交审核</el-button>
					<el-button type="primary" @click="printInitHandle">打印具体计划单</el-button>
				</template>
			</avue-form>
		</basic-container>
		<el-dialog title="具体计划单" width="80%" :visible.sync="pdflVisible" custom-class="common-dialog"
			class="avue-dialog">
			<csPdf :info="form" @close="pdflVisible = false" :initId="$route.query.id"></csPdf>
		</el-dialog>
	</div>
</template>
<script>
	import {
		getOrderInfo
	} from "@/api/order/index";
	import {
		getOrderInitPlanList,
		submitAuditHandle
	} from '@/api/order/orderinit'
	// import website from '@/config/website';
	import {
		mapGetters
	} from "vuex";
	import {
		getDetail
	} from '@/api/base/region'
	// import { cardid } from '@/util/validate'
	import orderinitDetail from '@/components/orderinit/detail.vue'
	import orderinit from '@/components/orderinit/index.vue'
	import csPdf from '@/views/archives/components/jtjh-pdf.vue'
	import {
		getDictTree
	} from "@/api/system/dictbiz"
	export default {
		name: 'order-update',
		components: {
			orderinitDetail,
			csPdf,
			orderinit
		},
		data() {
			// var checkCardid = (rule, value, callback) => {
			//   let list = cardid(value);
			//   if (list[0]) {
			//     return callback(new Error(list[1]));
			//   } else {
			//     callback();
			//   }
			// };
			return {
				pdflVisible: false,
				planList: [],
				form: {},
				submitBtnLoading:false,
				option: {
					submitBtn: false,
					emptyBtn: false,
					size: 'mini',
					group: [{
						label: '订单信息',
						prop: 'orderInfo',
						labelWidth: 120,
						column: [{
								label: "发布人",
								prop: "orderCreateUserName",
								disabled: true
							}, {
								label: "选择机构",
								prop: "orderCreateDeptName",
								disabled: true
							},
							{
								label: "呼叫类型",
								prop: "type",
								type: "select",
								dataType: 'string',
								dicUrl: "/api/blade-system/dict-biz/dictionary",
								dicQuery: {
									code: 'work_type',
								},
								props: {
									label: "dictValue",
									value: "dictKey"
								},
								formatter: (row, value, label) => {
									return label
								},
								disabled: true
							},
							{
								label: "五类青少年",
								prop: "teenagersType",
								bind: 'orderPersonalData.teenagersType',
								type: "select",
								dicUrl: "/api/blade-system/dict-biz/dictionary",
								dataType: 'number',
								dicQuery: {
									code: 'Five-youth_types'
								},
								props: {
									label: "dictValue",
									value: "dictKey"
								},
								disabled: true
							},
							{
								label: "优先级",
								prop: "priority",
								bind: 'orderPersonalData.priority',
								type: "select",
								dicUrl: "/api/blade-system/dict-biz/dictionary",
								dicQuery: {
									code: 'priority'
								},

								props: {
									label: "dictValue",
									value: "dictKey"
								},
								disabled: true
							},
							{
								label: "颜色标注",
								prop: "orderColor",
								type: "select",
								dicUrl: "/api/blade-system/dict-biz/dictionary",
								dicQuery: {
									code: 'Color'
								},

								props: {
									label: "dictValue",
									value: "dictKey"
								},
								disabled: true
							}
						]
					}, {
						label: '基本信息',
						prop: 'baseInfo',
						labelWidth: 120,
						column: [{
								label: "头像",
								prop: "photoUrl",
								bind: 'orderPersonalData.photoUrl',
								type: 'upload',
								listType: 'picture-img',
								loadText: '图片上传中，请稍等',
								tip: '只能上传jpg/png图片，且不超过500kb',
								// formslot: true,
								action: '/api/blade-resource/oss/endpoint/put-file-attach',
								propsHttp: {
									res: 'data',
									url: 'link'
								},
								data: {
									fileName: 'avatar'
								},
								span: 24,
								row: true,
								disabled: true
							}, {
								label: "姓名",
								prop: 'name',
								bind: "orderPersonalData.name",
								disabled: true,
							},
							{
								label: "身份证",
								prop: "cardNo",
								bind: 'orderPersonalData.cardNo',
								hide: true,
								disabled: true,
							},
							{
								label: "性别",
								prop: "gender",
								bind: 'orderPersonalData.gender',
								type: 'select',
								dataType: "number",
								dicUrl: "/api/blade-system/dict-biz/dictionary",
								dicQuery: {
									code: 'sex'
								},
								props: {
									label: "dictValue",
									value: "dictKey"
								},
								disabled: true,
								span: 8
							},
							{
								label: "出生年月",
								prop: 'birthday',
								bind: "orderPersonalData.birthday",
								type: "date",
								format: "yyyy-MM-dd",
								valueFormat: "yyyy-MM-dd",
								hide: true,
								disabled: true,
								span: 8
							},
							{
								label: "联系电话",
								prop: 'contact',
								bind: "orderPersonalData.contact",
								disabled: true,
								span: 8
							},
							{
								label: "籍贯",
								prop: 'nativePlace',
								bind: "orderPersonalData.nativePlace",
								disabled: true,
							}, {
								label: "健康情况",
								prop: 'healthyState',
								bind: "orderPersonalData.healthyState",
								dataType: 'number',
								type: "select",
								dicUrl: "/api/blade-system/dict-biz/dictionary",
								dicQuery: {
									code: 'healthy'
								},
								props: {
									label: "dictValue",
									value: "dictKey"
								},
								disabled: true,
							},
							{
								label: '户籍所在区域',
								prop: 'residenceProvince',
								bind: 'orderPersonalData.residenceProvince',
								type: 'select',
								props: {
									label: 'name',
									value: 'code'
								},
								cascaderItem: ['residenceCity', 'residenceDistrict'],
								dicUrl: '/api/blade-system/region/select',
								span: 8,
								// change: (value) => {
								//     if (value.value) {
								//         this.code = value.value
								//         this.getDeptHandle()
								//     }
								// },
								disabled: true,
							},
							{
								labelWidth: 0,
								placeholder: '请选择',
								prop: 'residenceCity',
								bind: 'orderPersonalData.residenceCity',
								type: 'select',
								props: {
									label: 'name',
									value: 'code'
								},
								cascaderItem: ['residenceDistrict'],
								dicFlag: false,
								dicUrl: '/api/blade-system/region/select?code={{key}}',
								span: 8,
								// change: (value) => {
								//     if (value.value) {
								//         this.code = value.value
								//         this.getDeptHandle()
								//     }
								// },
								disabled: true,
							},
							{
								labelWidth: 0,
								placeholder: '请选择',
								prop: 'residenceDistrict',
								bind: 'orderPersonalData.residenceDistrict',
								type: 'select',
								props: {
									label: 'name',
									value: 'code'
								},
								dicFlag: false,
								dicUrl: '/api/blade-system/region/select?code={{key}}',
								span: 8,
								// change: (value) => {
								//     if (value.value) {
								//         this.code = value.value
								//         this.getDeptHandle()
								//     }
								// },
								disabled: true,
							}, {
								label: "详细地址",
								prop: "residenceAddress",
								bind: 'orderPersonalData.residenceAddress',
								span: 24,
								disabled: true,
							}, {
								label: '居住所在区域',
								prop: 'actualResidenceProvince',
								bind: 'orderPersonalData.actualResidenceProvince',
								type: 'select',
								props: {
									label: 'name',
									value: 'code'
								},
								cascaderItem: ['actualResidenceCity', 'actualResidenceDistrict'],
								dicUrl: '/api/blade-system/region/select',
								span: 8,
								disabled: true,
							},
							{
								labelWidth: 0,
								placeholder: '请选择',
								prop: 'actualResidenceCity',
								bind: 'orderPersonalData.actualResidenceCity',
								type: 'select',
								cascaderItem: ['actualResidenceDistrict'],
								props: {
									label: 'name',
									value: 'code'
								},
								dicFlag: false,
								dicUrl: '/api/blade-system/region/select?code={{key}}',
								span: 8,
								disabled: true,
							},
							{
								labelWidth: 0,
								placeholder: '请选择',
								label: '',
								prop: 'actualResidenceDistrict',
								bind: 'orderPersonalData.actualResidenceDistrict',
								type: 'select',
								props: {
									label: 'name',
									value: 'code'
								},
								dicFlag: false,
								dicUrl: '/api/blade-system/region/select?code={{key}}',
								span: 8,
								disabled: true,
							},
							{
								label: "详细地址",
								prop: "actualResidentialAddress",
								bind: 'orderPersonalData.actualResidentialAddress',
								span: 24,
								disabled: true,
							}
						]
					}, {
						label: '涉案情况',
						prop: 'shean',
						labelWidth: 130,
						column: [{
								label: "案件类型",
								prop: "crimeType",
								// type: "select",
								type: 'cascader',
								dataType: "string",
								// checkStrictly:true,
								showAllLevels: false,
								emitPath: false,
								// dicUrl: "/api/blade-system/dict-biz/dictionary",
								// dicQuery: {
								//     code: 'crime_types'
								// },
								props: {
									label: "dictValue",
									value: "dictKey"
								},
								disabled: true,
								row: true,
							}, {
								label: "情况描述",
								prop: "crimeSituation",
								type: 'textarea',
								span: 24,
								disabled: true,
							},
							// {
							//     label: "危险因素",
							//     prop: "hazard",
							//     type: "select",
							//     dicUrl: "/api/blade-system/dict-biz/dictionary",
							//     props: {
							//         label: "dictValue",
							//         value: "dictKey"
							//     },
							//     dicQuery: {
							//         code: 'critical_factors_ype'
							//     },
							//     disabled: true,
							// }, {
							//     label: "危急因素备注",
							//     prop: "hazardRemark",
							//     disabled: true,
							// },
							{
								label: "紧急服务",
								prop: "emergencyServices",
								type: "select",
								dataType: "number",
								dicData: [{
									label: '需要',
									value: 0
								}, {
									label: '不需要',
									value: 1
								}],
								disabled: true,
							}, {
								label: "紧急服务备注",
								prop: "emergencyServicesRemarks",
								disabled: true,
							},
							// {
							//     label: "案情概述",
							//     prop: "summarize",
							//     type: "textarea",
							//     span: 24,
							//     disabled: true,
							// },
							// {
							//     label: "案情详情",
							//     prop: "detail",
							//     type: "textarea",
							//     span: 24,
							//     disabled: true,
							// },
						]
					}, {
						label: '当前初始计划单',
						prop: 'jh',
						column: [{
							labelWidth: 0,
							prop: 'init',
							formslot: true,
							row: true,
							span: 24,
						}]
					}, {
						label: '具体计划单',
						prop: 'shean',
						column: [{
							labelWidth: 0,
							prop: 'detailInit',
							formslot: true,
							row: true,
							span: 24,
						}]
					}]
				}
			}
		},
		computed: {
			...mapGetters(["userInfo", "permission"]),
		},
		mounted() {
			this.getOrderDetail()
			this.getInitPlanList()
			let column2 = this.findObject(this.option.group, 'crimeType')
			getDictTree().then(res => {
				column2.dicData = res.data.data.filter(v => v.code == 'crime_types')[0].children
			})
		},
		methods: {
			getInitPlanList() {
				getOrderInitPlanList(this.$route.query.id).then(res => {
					this.planList = res.data.data
				})
			},
			getOrderDetail() {
				getOrderInfo(this.$route.query.orderId).then(res => {
					let data = res.data.data
					if (data.orderPersonalData.residenceRegionCode) {
						getDetail(data.orderPersonalData.residenceRegionCode).then(data1 => {
							data.orderPersonalData.residenceProvince = data1.data.data.provinceCode
							data.orderPersonalData.residenceCity = data1.data.data.cityCode
							data.orderPersonalData.residenceDistrict = data1.data.data.districtCode
							this.form = data
							this.form.orderInitialPlanList = data.orderInitialPlanList.filter(v => v.id ==
								this.$route.query.id)
							this.$nextTick(() => {
								this.$refs.form.clearValidate();
							})
						})
					} else {
						this.form = data
					}
				})
			},
			submit() {
                // console.info(this.form.orderInitialPlanList)
				if (!this.form.orderInitialPlanList || this.form.orderInitialPlanList.length == 0 || this.form.orderInitialPlanList[0].orderSpecificList.length==0) {
					this.$message.error("请先根据初始计划单添加具体计划单内容后提交！")
					return
				}
				this.submitBtnLoading=true;
				submitAuditHandle(this.$route.query.id).then(() => {
					this.$message({
						type: "success",
						message: "已提交审核!"
					});
					// 数据回调进行刷新
					this.submitBtnLoading=false;
					this.$refs.form.resetForm();
					this.$router.$avueRouter.closeTag()
					this.$router.go(-1)
				}, error => {
					this.submitBtnLoading=false;
					window.console.log(error);
				});
			},
			//具体计划单操作
			returnInfoEven(data) {
				this.form.orderInitialPlanList[0].orderSpecificList = data;
			},
			getorderInitialPlanList(list) {
				this.$set(this.form, 'orderInitialPlanList', list)
			},
			// 打印具体计划单
			printInitHandle() {
				if (!this.form.orderInitialPlanList || this.form.orderInitialPlanList.length == 0) {
					this.$message.error("请先添加具体计划单内容后打印")
					return
				}
				this.pdflVisible = true
			},
			error() {
				this.$message.success('请填写完整具体计划单信息');
			}
		}

	}
</script>
<style lang="scss" scoped="scoped">
	@import "@/styles/moudles/order.scss";
</style>
